module.exports = __webpack_public_path__ + "static/media/image (20).235b28a0.jpg";